module.exports = __webpack_public_path__ + "img/spawner-die-01.11986046.png";